import { useEffect, useState } from "react";
import { TTask } from "../../types";
import { TCourse } from "../../types";
import { useCourseContext } from "../../context/courseContext";
import { useAuthContext } from "../../context/authContext";
import TaskFooter from "./TaskFooter";
import TaskHeader from "./TaskHeader";
import TaskItemLayer from "./TaskItemLayer";
import Loading from "../../shared/loading";
import { Fab, Tooltip } from "@mui/material";
import { Button } from "../../shared/button";
import { ym } from "react-metrika";

type TTaskListProps = {
  tasks: TTask[];
  course: TCourse;
};

function TaskList(props: TTaskListProps) {
  const { tasks, course } = props;

  const {
    handleSubmit,
    isClickedCheck,
    isCheckButtonDisabled,
    setCheckButtonDisabled,
    checkedTasks,
    answersList,
    resetAll,
  } = useCourseContext();

  const { authInfo } = useAuthContext();

  const [isCoursesLoading, setIsCoursesLoading] = useState<boolean>(false);

  if (course.title) {
    document.title = course.title.replace(/%course_id/g, course.id.toString());
  } else {
    const title = document.querySelector("title");
    if (title) {
      document.head.removeChild(title);
    }
  }

  const onClick = async (e: any) => {
    e.preventDefault();
    setIsCoursesLoading(true);
    await handleSubmit(e).then(() => {
      if (
        window.location.host !== "test.minimath239.ru" &&
        window.location.host !== "localhost:3000"
      ) {
        ym(102385331, "reachGoal", "btn_send_result");
      }
      setIsCoursesLoading(false);
    });
  };

  tasks.forEach((t, i) => {
    if (!t.rootId) {
      t.displayIndex = i + 1;
    }
  });

  const answeredTasksWithRoot = tasks.filter(
    (x) =>
      checkedTasks.map((z) => z.rootId).includes(x.id) ||
      checkedTasks.map((y) => y.taskId).includes(x.id),
  );

  const tasksToShow = !isClickedCheck ? tasks : answeredTasksWithRoot;

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   return () => {
  //     resetAll();
  //   };
  // }, [resetAll]);

  useEffect(() => {
    const somethingEntered = Object.keys(answersList).length
      ? Object.keys(answersList).reduce(
          (s, k) => (s += answersList[k].length),
          0,
        )
      : 0;
    setCheckButtonDisabled(!somethingEntered);
  }, [answersList, setCheckButtonDisabled]);

  if (!tasks) {
    return <h1 style={{ textAlign: "center" }}>Нет задач.</h1>;
  }

  return (
    <>
      {isCoursesLoading ? (
        <Loading />
      ) : (
        <div>
          <TaskHeader
            course={course}
            isClickedCheck={isClickedCheck}
            authInfo={authInfo}
          />

          <TaskItemLayer
            checkedTasks={checkedTasks}
            isClickedCheck={isClickedCheck}
            tasksToShow={tasksToShow}
            answersList={answersList}
          />

          {isClickedCheck ? (
            <div className="TaskBackToTasksButton">
              <Button
                onClick={() => {
                  resetAll();
                }}
              >
                Вернуться к задачам
              </Button>
            </div>
          ) : (
            <div className="TaskButtonLayer">
              <Tooltip title={"Проверить ответы"}>
                <span>
                  <Fab
                    size="large"
                    variant="extended"
                    disabled={isCheckButtonDisabled}
                    sx={{
                      width: 300,
                      backgroundColor: "#EB5E70",
                      "&:hover": {
                        backgroundColor: "#EB5E70",
                        color: "#FFFFFF",
                      },
                    }}
                    onClick={onClick}
                    aria-label="save"
                  >
                    Проверить ответы
                  </Fab>
                </span>
              </Tooltip>
            </div>
          )}
          <TaskFooter course={course} isClickedCheck={isClickedCheck} />
        </div>
      )}
    </>
  );
}

export default TaskList;
